import { render } from "./AiServicesConfigurationForm.vue?vue&type=template&id=74de56ef&ts=true"
import script from "./AiServicesConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./AiServicesConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__